import { filter, map, of, switchMap } from 'rxjs';
// introduced in 2026. multiple classes are using custom implementations (but are hard to find.)
// custom solutions can be replaced by this whenever found.
export function whenFormServiceInitialized$(formService$) {
  return formService$.pipe(switchMap(fs => {
    const ready$ = (() => {
      if (!fs) return of(false);
      if (fs.initialized) return of(true);
      return fs.initialized$.pipe(filter(ready => !!ready));
    })();
    return ready$.pipe(map(ready => {
      if (!ready) return null;
      return fs;
    }));
  }));
}